function normalizeContent(content?: string | null): string {
  if (!content) {
    return "";
  }
  return content.trim().replace(/\s+/g, " ").toLowerCase();
}

function getQuestionKey(question: any): string {
  const rawContent =
    question?.question?.content ?? question?.questionContent ?? question?.content ?? "";
  const content = normalizeContent(rawContent);
  if (content) {
    return `content:${content}`;
  }
  if (question?.questionId != null) {
    return `id:${question.questionId}`;
  }
  if (question?.id != null && (typeof question.id === "number" || typeof question.id === "string")) {
    return `id:${question.id}`;
  }
  return `index:${Math.random()}`;
}

export function deduplicateQuestions<T>(questions: T[]): T[] {
  const seen = new Set<string>();
  const result: T[] = [];
  for (const question of questions) {
    const key = getQuestionKey(question);
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    result.push(question);
  }
  return result;
}

export function shuffleArray<T>(array: T[]): T[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

/** Loại trùng rồi shuffle, lấy `displayCount` câu nếu hợp lệ. */
export function pickDisplayedQuestions<T>(questions: T[], displayCount?: number | null, _seed?: number): T[] {
  const uniqueQuestions = deduplicateQuestions(questions);
  if (!uniqueQuestions.length) {
    return [];
  }
  if (displayCount == null || displayCount <= 0 || displayCount >= uniqueQuestions.length) {
    return uniqueQuestions;
  }
  return shuffleArray(uniqueQuestions).slice(0, displayCount);
}

export function isLimitedDisplay(displayCount: number | null | undefined, total: number): boolean {
  return displayCount != null && displayCount > 0 && displayCount < total;
}
